module.exports = __webpack_public_path__ + "img/wish-h5.3fc74011.webp";